export class PersonaProviderProfile {
  acceptingClients: boolean;
  acceptingSamClients: boolean;
  allowsConsultation: boolean;
  id: number;
  matchingEnabled: boolean;
  noPhysicalLocation: boolean;
  sessionTypesOffered: string[];
  directSchedulingEnabled: string;
  education_level?: IPersonaProviderEducationLevel;
  reachedNotifiedLimit: boolean;
  lgbtIdentified: string;
  psychiatrist: boolean;
  transcriptionConsentAt: string | null;
  transcriptionRevokedConsentAt: string | null;
  rcopiaCredentials?: IRcopiaCredentials;
  saasEnabled: boolean;

  constructor(response: IPersonaProviderProfileResponse) {
    this.acceptingClients = response.accepting_clients;
    this.acceptingSamClients = response.accepting_sam_clients;
    this.allowsConsultation = response.allows_consultation;
    this.id = response.id;
    this.matchingEnabled = response.matching_enabled;
    this.noPhysicalLocation = response.no_physical_location;
    this.sessionTypesOffered = response.session_types_offered;
    this.directSchedulingEnabled = response.direct_scheduling_enabled;
    this.reachedNotifiedLimit = response.reached_notified_limit;
    this.lgbtIdentified = response.lgbt_identified;
    this.psychiatrist = response.psychiatrist;
    this.transcriptionConsentAt = response.transcription_consent_at;
    this.transcriptionRevokedConsentAt = response.transcription_revoked_consent_at;
    this.education_level = response.education_level;
    this.rcopiaCredentials = response.rcopia_credentials;
    this.saasEnabled = response.saas_enabled;
  }
}

export interface IPersonaProviderEducationLevel {
  id: number;
  title: string;
}

export interface IPersonaProviderProfileResponse {
  accepting_clients: boolean;
  accepting_sam_clients: boolean;
  allows_consultation: boolean;
  id: number;
  matching_enabled: boolean;
  no_physical_location: boolean;
  direct_scheduling_enabled: string;
  session_types_offered: string[];
  reached_notified_limit: boolean;
  lgbt_identified: string;
  psychiatrist: boolean;
  transcription_consent_at: string | null;
  transcription_revoked_consent_at: string | null;
  education_level: IPersonaProviderEducationLevel;
  rcopia_credentials?: IRcopiaCredentials;
  /**
   * If true, this means that a provider is using SonderMind as a SAAS platform.
   * SAAS providers have a significantly different experience to normal providers.
   * This allows us to control their experience and hide certain features.
   * Most notable is that SAAS providers do not have matches.
   * Their only clients are PSC (provider-sourced, manual).
   * As a result, they also have no need for a profile or PSL.
   * Finally, SAAS providers cannot accept insurance.
   */
  saas_enabled: boolean;
}

export interface IRcopiaCredentials {
  rcopia_user_name: string;
  login_password: string;
  signature_password: string;
}

export enum LgbtIdentifiedOptions {
  YES = 'yes',
  NO = 'no',
  PREFER_NOT_TO_SAY = 'prefer_not_to_say'
}
